(function (mod) {
    window.$modules = mod = mod || {};

    mod['banner-post'] = context => {
        const { $el } = context;
        const $slides = $el.find('.slide-list .slide');
        const $banner = $el.find('.banner.banner-carousel');
        const $bannerOverlay = $el.find('.trans-banner-overlay');
        const $arrowPrev = $el.find('.arrow-prev');
        const $arrowNext = $el.find('.arrow-next');
        const transitionSpeed = 750;
        let currentSlide = 0;
        let thinking = false;


        const moveToSlide = i => {
            if (thinking || i == currentSlide) {
                return;
            }
            thinking = true;

            if (i > $slides.length - 1) {
                i = 0;
            } else if (i < 0) {
                i = $slides.length - 1;
            }
            currentSlide = i;
            const $slide = $slides.eq(i);
            const imgSrc = $slide.find('img').attr('src');
            const img = new Image();
            img.src = imgSrc;
            img.onload = () => {
                $bannerOverlay.css({
                    'background-image': `url(${imgSrc})`,
                    'background-size': 'contain',
                    'banner-repeat': 'no-repeat',
                });
                $bannerOverlay.fadeIn(transitionSpeed, () => {
                    $banner.css({
                        'background-image': `url(${$slide.find('img').attr('src')})`,
                        'background-size': 'contain',
                        'banner-repeat': 'no-repeat',
                    })
                    thinking = false;
                    $bannerOverlay.hide();
                });
            }

            return false;
        }

        const nextSlide = () => {
            return moveToSlide(currentSlide + 1);
        }

        const prevSlide = () => {
            return moveToSlide(currentSlide - 1);
        }

        const init = () => {
            if ($slides.length < 2) {
                $arrowNext.hide();
                $arrowPrev.hide();
                return;
            }
            $arrowPrev.click(prevSlide);
            $arrowNext.click(nextSlide);
        }

        init();
    };
})(window.$modules);